import React from 'react';
import { ButtonIcon } from '../../components';

const InfoButton = ({ ...other }: Record<string, unknown>): JSX.Element => (
  <ButtonIcon icon={'InfoCircle'} color={'transparent'} size={'md'} hideShadow hasPadding={false} {...other} data-cy="button-icon" type="button" data-hide-print/>
);

InfoButton.displayName = 'InfoButton';

export default InfoButton;
